module.exports = __webpack_public_path__ + "static/media/trash_can_black_thick.d6a6dfd3.svg";